import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import api, { formatApiErrorDetail } from '../services/api';

const Registro = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    tipo_persona: 'Natural',
    ruc: '',
    razon_social: '',
    email: '',
    celular: '',
    direccion: '',
    password: '',
    confirmPassword: '',
    rol: 2
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (formData.password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);
    try {
      const { confirmPassword, ...usuarioData } = formData;
      // Asegurar que el rol sea 2 (PROVEEDOR) para usuarios que se registran desde la plataforma
      usuarioData.rol = 2;
      const response = await api.post('/api/v1/email/register', usuarioData);
      // Redirigir a la página de verificación de correo con el email del usuario
      navigate('/check-email', { 
        state: { email: formData.email } 
      });
    } catch (error) {
      console.error('Error registering user:', error);
      setError(formatApiErrorDetail(error, 'Error al registrar usuario. Verifique los datos ingresados.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center justify-content-center py-5"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Container>
        <div className="d-flex justify-content-center">
          <Card className="shadow-lg border-0" style={{ maxWidth: '700px', width: '100%' }}>
            <Card.Body className="p-4 p-md-5">
              <div className="text-center mb-4">
                <img 
                  src="/LOGO-DIRESA.png" 
                  alt="Logo DIRESA" 
                  className="mb-3"
                  style={{ maxHeight: '80px', width: 'auto' }}
                />
                <h2 className="fw-bold text-primary mb-2">Registro de Usuario</h2>
                <p className="text-muted">Complete el formulario para crear su cuenta</p>
              </div>

              {error && (
                <Alert variant="danger" dismissible onClose={() => setError('')} className="mb-4">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={12} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-person-badge me-2"></i>
                      Tipo de Persona
                    </Form.Label>
                    <Form.Select
                      value={formData.tipo_persona}
                      onChange={(e) => setFormData({ ...formData, tipo_persona: e.target.value })}
                      size="lg"
                      className="border-2"
                      disabled={loading}
                    >
                      <option value="Natural">Persona Natural</option>
                      <option value="Jurídica">Persona Jurídica</option>
                    </Form.Select>
                  </Col>
                </Row>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-credit-card me-2"></i>
                      RUC
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="10456925991"
                      value={formData.ruc}
                      onChange={(e) => setFormData({ ...formData, ruc: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-person me-2"></i>
                      Razón Social / Nombre
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nombre completo o Razón Social"
                      value={formData.razon_social}
                      onChange={(e) => setFormData({ ...formData, razon_social: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-envelope me-2"></i>
                      Correo electrónico
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="tu@email.com"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-phone me-2"></i>
                      Celular
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="901994417"
                      value={formData.celular}
                      onChange={(e) => setFormData({ ...formData, celular: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-geo-alt me-2"></i>
                      Dirección
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Dirección completa"
                      value={formData.direccion}
                      onChange={(e) => setFormData({ ...formData, direccion: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-lock-fill me-2"></i>
                      Contraseña
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Mínimo 6 caracteres"
                      value={formData.password}
                      onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                      minLength={6}
                    />
                    <Form.Text className="text-muted">
                      Mínimo 6 caracteres
                    </Form.Text>
                  </Col>

                  <Col md={6} className="mb-4">
                    <Form.Label className="fw-semibold">
                      <i className="bi bi-lock-fill me-2"></i>
                      Confirmar Contraseña
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Repita la contraseña"
                      value={formData.confirmPassword}
                      onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                      required
                      disabled={loading}
                      size="lg"
                      className="border-2"
                      minLength={6}
                    />
                  </Col>
                </Row>

                <Button
                  variant="primary"
                  type="submit"
                  disabled={loading}
                  size="lg"
                  className="w-100 mb-3 fw-semibold"
                >
                  {loading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Registrando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-person-plus me-2"></i>
                      Registrarse
                    </>
                  )}
                </Button>
              </Form>

              <div className="text-center">
                <p className="text-muted mb-0">
                  ¿Ya tienes una cuenta?{' '}
                  <Link to="/login" className="text-decoration-none fw-semibold">
                    Iniciar Sesión
                  </Link>
                </p>
                <Link to="/" className="text-decoration-none text-muted small d-block mt-2">
                  <i className="bi bi-arrow-left me-1"></i>
                  Volver al inicio
                </Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default Registro;
